import {
  CollectiveAdvice,
  NeedName,
} from "Store/akaAdvice/interfaces/CollectiveAdvice";

import { FormikProps } from "formik";
import React from "react";
import { AdviceCards } from "../AkaAdviceCards";
import { AdviceTotalPrice } from "../AkaAdviceCards/AdvicePrice/AdviceTotalPrice";
import { AkaAdvicePriceFormValues } from "../AkaAdviceCards/interfaces";
import { AkaAdviceScreenshot } from "../AkaAdviceScreenshot/AkaAdviceScreenshot";
import { IndividualAdviceIntro } from "./IndividualAdviceIntro";

import { isAnyCoverageAllowed } from "Store/akaAdvice/interfaces/getters";
import { isDefined } from "Utils/functions";
import { useEntrance } from "../../ProductPrice/hooks/useEntrance";
import { AdviceFeedback } from "../../adviceStyled";
import { AdviceDiffMessages } from "../AkaAdviceMessages/AdviceDiffMessages";
import { entranceToNeed, sortNeeds } from "../utils";

interface Props {
  formProps: FormikProps<AkaAdvicePriceFormValues>;
  collectiveAdvice: CollectiveAdvice;
  akaAdviceScreenshot: AkaAdviceScreenshot;
}

export const IndividualAdviceForm = ({
  formProps,
  collectiveAdvice,
  akaAdviceScreenshot,
}: Props): React.ReactElement => {
  const entrance = useEntrance();
  const needEntrance = entranceToNeed(entrance);
  const cardWeights = !isDefined(entrance) ? {} : { [entrance]: 0.1 };
  const needWeights = !isDefined(needEntrance) ? {} : { [needEntrance]: 0.1 };
  const sortedNeeds = sortNeeds(
    Object.entries(collectiveAdvice.needs).map(([name, coverageNeed]) => ({
      name: name as NeedName,
      coverageNeed,
    })),
    needWeights,
  );

  return (
    <div ref={akaAdviceScreenshot.screenshotRefCallback}>
      <IndividualAdviceIntro
        collectiveAdvice={collectiveAdvice}
        sortedNeeds={sortedNeeds}
      />
      <AdviceCards
        isCollectiveAdvice={false}
        formProps={formProps}
        collectiveAdvice={collectiveAdvice}
        addedWeights={cardWeights}
      />
      {isAnyCoverageAllowed(collectiveAdvice) && (
        <>
          <AdviceFeedback id="adviceFeedback"></AdviceFeedback>
          <AdviceDiffMessages
            sortedNeeds={sortedNeeds}
            formProps={formProps}
            akaAdviceScreenshot={akaAdviceScreenshot}
          />
        </>
      )}
      <AdviceTotalPrice formProps={formProps} />
    </div>
  );
};
